__webpack_require__.p = "https://lnp-login-ui.stage.kea.aws.ssctech.com/";